import { Flex } from "@chakra-ui/react";

function TableHeaderRow() {
  return (
    <>
      <Flex flex={1.5}>
        <Flex ml={8}>Descrição</Flex>
      </Flex>

      <Flex flex={1} justifyContent="flex-end">
        Geração
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        Vencimento
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        Liquidação
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        Crédito
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        Centro de Custo
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        Nosso Número
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        Valor
      </Flex>
    </>
  );
}

export default TableHeaderRow;
